export default __webpack_public_path__ + "static/media/img1.1e99b64b.jpg";